'use client'
import type { ReactNode } from 'react'
import { cx } from '../utils'

export function Label({
  children,
  required,
  className,
}: {
  children: ReactNode
  required?: boolean
  className?: string
}) {
  return (
    <span className={cx('text-[13px] font-medium tracking-[0.08em] text-ink-2 uppercase', className)}>
      {children}
      {required && <span className="text-danger"> *</span>}
    </span>
  )
}
